import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Company as ICompanyData } from 'types/common'

export type InitialState = typeof initialState

interface IState {
  companyData: ICompanyData | null
  loading: boolean
  error: boolean
}

export const initialState: IState = {
  companyData: null,
  loading: false,
  error: false,
}

const companySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    setCompanyData(state, action: PayloadAction<ICompanyData>) {
      state.companyData = action.payload
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload
    },
    setError(state, action: PayloadAction<boolean>) {
      state.error = action.payload
    },
    clearCompanyData(state) {
      state.companyData = null
      state.loading = false
      state.error = false
    },
  },
})

export const { setCompanyData, setLoading, setError, clearCompanyData } = companySlice.actions

export const companyReducer = companySlice.reducer
